import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {EntitiesRecognizerFactory} from "./entities-recognizer.factory";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";

export class EntitiesRecognizerApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, EntitiesRecognizerFactory];
}

